import { ComplexList, DefaultEdit, ObserveList } from 'complex-data'
import vehicleApi from '@/pages/index/api/vehicle'
import { buildDictionaryBySelect } from '@/config/dictionary'
import { vehicleRedeemType } from '@/pages/index/select/vehicle'
import { ApprovalStatus } from '@/pages/index/select'
import { dict } from '@/pages/index/select/dict'
import LayoutParse from '@/config/utils/layout'
import { notice } from 'complex-plugin'
import { listWidth } from '@/config/dictionary/config'
import { uploadFile } from '@/pages/index/utils/file'
import { RegExpRule } from '@/config/utils'
import config from '@/config'
import old from '@/pages/index/data/old'
import { getNum } from 'complex-utils'

export class RedeemList extends ComplexList {
  buildItem(postData: Record<string, unknown>, payload: { id: string }) {
    return new Promise((resolve, reject) => {
      postData.overdueRecordId = payload.id
      vehicleApi.vehicleRedeemBuild.require(postData).then(() => {
        notice.showMsg('车辆赎回申请成功！', 'success')
        resolve({ status: 'success' })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
  changeItem(postData: Record<string, unknown>, payload: { id: string }, originData: Record<string, unknown>, flowKey: string) {
    return new Promise((resolve, reject) => {
      postData.id = originData.id
      postData.taskId = payload.id
      postData.curTaskDefKey = flowKey
      vehicleApi.vehicleRedeemChange.require(postData).then(() => {
        notice.showMsg('车辆赎回申请审批成功！', 'success')
        resolve({ status: 'success' })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
  rejectItem(postData: Record<string, unknown>, payload: { id: string }, originData: Record<string, unknown>) {
    return new Promise((resolve, reject) => {
      postData.id = originData.id
      postData.taskId = payload.id
      vehicleApi.vehicleRedeemReject.require(postData).then(() => {
        notice.showMsg('车辆赎回申请驳回完成！', 'success')
        resolve({ status: 'success' })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
  settleItem(targetData: Record<string, unknown>) {
    return new Promise((resolve, reject) => {
      if (!targetData.initEarlySettlementTaskno) {
        vehicleApi.vehicleRedeemSettle.require({
          id: targetData.id as string
        }).then((res) => {
          targetData.initEarlySettlementFlowunit = res.data.data.initEarlySettlementFlowunit
          targetData.initEarlySettlementTaskno = res.data.data.initEarlySettlementTaskno
          old.toSettlement(targetData.initEarlySettlementTaskno as string)
          resolve({ status: 'success' })
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.error(err)
          reject(err)
        })
      } else {
        old.toSettlement(targetData.initEarlySettlementTaskno as string)
        resolve({ status: 'success' })
      }
    })
  }
}

const layoutParse = new LayoutParse(2, 8, 16)

const searchLayoutParse = new LayoutParse(4, 8, 16)

type editConfigType = {
  amountInit?: boolean
  reduction?: string
  reductionName?: string
  count?: {
    type?: string[]
    trigger?: boolean
    change?: (target: ObserveList, value: number, type: string) => void
  }
  hidden?: (target: ObserveList, type?: string) => boolean
}

const editConfig = {
  data: {
    principalAmount: {
      // 本金
      count: {
        type: ['1']
      },
      amountInit: true,
      reduction: 'reductionPrincipalAmount',
      reductionName: '亏损'
    },
    reductionPrincipalAmount: {
      // 亏损后本金
      count: {
        type: ['2'],
        trigger: true
      },
      hidden(target: ObserveList, type?: string) {
        const principalAmountDictionary = target.getItem('principalAmount')!.$getParent()!
        if (type === '2') {
          principalAmountDictionary.$setLayout({
            default: layoutParse.getData(2)
          })
        } else {
          principalAmountDictionary.$setLayout({
            default: layoutParse.getData(1)
          })
        }
        return type !== '2'
      },
    },
    interestAmount: {
      // 利息
      count: {
        type: ['1']
      },
      reduction: 'reductionInterestAmount',
      hidden(target: ObserveList, type?: string) {
        const interestAmountDictionary = target.getItem('interestAmount')!.$getParent()!
        if (type === '2') {
          interestAmountDictionary.$setLayout({
            default: layoutParse.getData(2)
          })
        } else {
          interestAmountDictionary.$setLayout({
            default: layoutParse.getData(1)
          })
        }
        return false
      },
      amountInit: true,
    },
    reductionInterestAmount: {
      // 减免后利息
      count: {
        type: ['2'],
        trigger: true
      },
      hidden(target: ObserveList, type?: string) {
        return type !== '2'
      }
    },
    liquidatedAmount: {
      // 违约金
      amountInit: true,
      reduction: 'reductionLiquidatedAmount',
      hidden(target: ObserveList, type?: string) {
        return type !== '2'
      }
    },
    reductionLiquidatedAmount: {
      // 减免后违约金
      count: {
        type: ['2'],
        trigger: true
      },
      hidden(target: ObserveList, type?: string) {
        return type !== '2'
      }
    },
    hirePurchaseAmount: {
      // 留购价款
      reduction: 'reductionHirePurchaseAmount',
      amountInit: true,
      hidden(target: ObserveList, type?: string) {
        return type !== '2'
      }
    },
    reductionHirePurchaseAmount: {
      // 减免后留购价款
      count: {
        type: ['2'],
        trigger: true
      },
      hidden(target: ObserveList, type?: string) {
        return type !== '2'
      },
    },
    punishAmount: {
      // 罚息
      amountInit: true,
      reduction: 'reductionPunishAmount',
    },
    reductionPunishAmount: {
      // 减免后罚息
      count: {
        type: ['1', '2'],
        trigger: true
      },
    },
    collectionAmount: {
      // 收车费用
      amountInit: true,
      reduction: 'reductionCollectionAmount',
    },
    reductionCollectionAmount: {
      // 减免后收车费用
      count: {
        type: ['1', '2'],
        trigger: true
      },
    },
    parkAmount: {
      // 停车费用
      reduction: 'reductionParkAmount',
      count: {
        trigger: true,
        change(target, value) {
          changeAmountReductionRuleByType(target, editConfig.data.parkAmount, value)
        }
      },
    },
    reductionParkAmount: {
      // 减免后停车费用
      count: {
        type: ['1', '2'],
        trigger: true
      },
    },
  } as Record<string, editConfigType>
}

// 计算金额
function countAmount(target: ObserveList, currentProp: true | string) {
  let count = false
  if (currentProp === true) {
    count = true
  } else {
    const currentConfigItem = editConfig.data[currentProp]
    if (currentConfigItem && currentConfigItem.count) {
      if (currentConfigItem.count.change) {
        currentConfigItem.count.change(target, Number(target.$data![currentProp] || 0), target.$data!.redemptionType)
      }
      if (currentConfigItem.count.trigger) {
        count = true
      }
    }
  }
  if (count) {
    let totalAmount = 0
    const type = target.$data!.redemptionType
    if (type) {
      for (const prop in editConfig.data) {
        const editConfigItem = editConfig.data[prop]
        if (editConfigItem.count && editConfigItem.count.type && editConfigItem.count.type.indexOf(type) > -1) {
          const targetAmount = Number(target.$data![prop] || 0) * 100
          totalAmount += targetAmount
        }
      }
    }
    target.$data!.receivableAmount = getNum(totalAmount / 100)
  }
}

// 根据类型初始化金额限制
function initAmountReductionRuleByType(target: ObserveList, type?: string) {
  const vehicleAmount = target.$data!.vehicleAmount
  const index = (Number(type) || 1) - 1
  const currentAmount = vehicleAmount[index]
  for (const prop in editConfig.data) {
    const editConfigItem = editConfig.data[prop]
    let value = currentAmount[prop]
    if (!editConfigItem.amountInit && target.$data![prop] !== undefined) {
      value = target.$data![prop]
    }
    changeAmountReductionRuleByType(target, editConfigItem, value)
  }
}

// 根据初始值限制金额
function initAmountReductionRuleByValue(target: ObserveList) {
  for (const prop in editConfig.data) {
    const editConfigItem = editConfig.data[prop]
    changeAmountReductionRuleByType(target, editConfigItem, target.$data![prop])
  }
}
// 修改对应的减免限制
function changeAmountReductionRuleByType(target: ObserveList, editConfigItem: editConfigType, value?: number | string) {
  if (editConfigItem.reduction) {
    value = Number(value || 0)
    const reductionEdit = target.getItem(editConfigItem.reduction) as DefaultEdit<'inputNumber'>
    // reductionEdit.$option.max = value
    const rule = reductionEdit.$rules.getData('default')
    if (rule[1]) {
      rule[1].max = value
    } else {
      rule.push({
        type: 'number',
        message: (editConfigItem.reductionName || '减免') + '后费用不能超过原费用',
        min: 0,
        max: value
      })
    }
  }
}
// 根据类型初始化金额数据
function initAmountByType(target: ObserveList, type?: string) {
  const vehicleAmount = target.$data!.vehicleAmount
  const index = (Number(type) || 1) - 1
  const currentAmount = vehicleAmount[index]
  for (const prop in editConfig.data) {
    const editConfigItem = editConfig.data[prop]
    const value = Number(currentAmount[prop] || 0)
    if (editConfigItem.amountInit) {
      if (type) {
        target.$data![prop] = value
      } else {
        target.$data![prop] = undefined
      }
    }
  }
  target.$data!.settleDataSyncDate = currentAmount.settleDataSyncDate
}
// 根据类型显示对应字段
function showItemByType(target: ObserveList, type?: string) {
  if (type === '2') {
    // 赎回结清
    editConfig.data.principalAmount.count = undefined
    editConfig.data.principalAmount.reduction = 'reductionPrincipalAmount'
  } else {
    editConfig.data.principalAmount.count = {
      type: ['1']
    }
    editConfig.data.principalAmount.reduction = undefined
  }
  for (const prop in editConfig.data) {
    const editConfigItem = editConfig.data[prop]
    if (editConfigItem.hidden) {
      if (editConfigItem.hidden(target, type)) {
        target.hidden(prop)
        target.$data![prop] = undefined
      } else {
        target.show(prop)
      }
    }
  }
}

const flowEndConfig = {
  continue: ['payAmount', 'voucherList', 'paymentCollectionDate'],
  end: ['flowEndReason', 'flowEndDesc']
}

function onFlowEndChange(target: ObserveList, value: boolean) {
  flowEndConfig[value ? 'end' : 'continue'].forEach(prop => {
    const editItem = target.getItem(prop)!
    target.show(prop)
    editItem.required.setData('default', true)
  })
  flowEndConfig[value ? 'continue' : 'end'].forEach(prop => {
    const editItem = target.getItem(prop)!
    target.hidden(prop)
    target.$data![prop] = undefined
    editItem.required.setData('default', false)
  })
}

const redeemList = new RedeemList({
  name: '车辆赎回申请',
  prop: 'redeemList',
  module: {
    pagination: true,
    search: {
      module: {
        dictionary: {
          layout: {
            default: searchLayoutParse.getData(4)
          },
          list: [
            buildDictionaryBySelect(dict.business_lines_green, {
              prop: 'itemname',
              name: '业务线',
              originProp: 'itemname',
              originFrom: 'local',
              mod: {
                search: {
                  $target: 'edit'
                }
              }
            }, {
              onlyLabel: true
            }),
            {
              prop: 'contractNumber',
              name: '合同号',
              originProp: 'contractNumber',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            {
              prop: 'customerName',
              name: '承租人',
              originProp: 'customerName',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            {
              prop: 'createdName',
              name: '创建人',
              originProp: 'createdName',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            {
              prop: 'vinNo',
              name: '车架号',
              originProp: 'vinNo',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            {
              prop: 'engineNo',
              name: '发动机编号',
              originProp: 'engineNo',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            {
              prop: 'beginCreatedTime',
              name: '创建时间',
              originProp: 'beginCreatedTime',
              originFrom: 'local',
              layout: {
                default: searchLayoutParse.getData(2)
              },
              post(value, { targetData }) {
                if (value) {
                  targetData.endCreatedTime = (value as string[])[1]
                  return (value as string[])[0]
                }
              },
              mod: {
                search: {
                  $type: 'edit',
                  type: 'dateRange',
                  option: {
                    time: {}
                  }
                }
              }
            },
          ]
        }
      },
      menu: {
        list: []
      },
    },
    dictionary: {
      layout: {
        default: layoutParse.getData(2)
      },
      option: {},
      propData: {
        id: 'id'
      },
      list: [
        {
          prop: 'menu',
          name: '操作',
          originProp: 'menu',
          originFrom: 'local',
          mod: {
            list: {
              width: listWidth.getWidth(7),
              local: {
                fixed: 'left'
              },
            }
          }
        },
        {
          prop: 'id',
          name: 'ID',
          originProp: 'id',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'initEarlySettlementFlowunit',
          name: '初始化老系统提前结清流程id',
          originProp: 'initEarlySettlementFlowunit',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'initEarlySettlementTaskno',
          name: '初始化老系统提前结清任务号',
          originProp: 'initEarlySettlementTaskno',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'code',
          name: '申请编号',
          originProp: 'code',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.getWidth(0, 11, 2)
            }
          }
        },
        {
          prop: 'overdueRecordId',
          name: '逾期记录ID',
          originProp: 'overdueRecordId',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'applyUserId',
          name: '申请人ID',
          originProp: 'applyUserId',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'contractNumber',
          name: '合同号',
          originProp: 'contractNumber',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.contractNumber
            }
          }
        },
        {
          prop: 'itemname',
          name: '业务线',
          originProp: 'itemname',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.businessLine
            }
          }
        },
        {
          prop: 'customerName',
          name: '承租人',
          originProp: 'customerName',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.personnelName
            }
          }
        },
        {
          prop: 'brandname',
          name: '品牌',
          originProp: 'brandname',
          originFrom: 'list',
          mod: {
            list: {}
          }
        },
        {
          prop: 'vinNo',
          name: '车架号',
          originProp: 'vinNo',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.vin
            }
          }
        },
        {
          prop: 'engineNo',
          name: '发动机编号',
          originProp: 'engineNo',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.vehicleEngineNo
            }
          }
        },
        {
          prop: 'settleDataSyncDate',
          name: '价格时间',
          originProp: 'settleDataSyncDate',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'input',
              observe(this: DefaultEdit, target, prop, val, from) {
                if (from === 'init' && prop === this.prop) {
                  if (target.$order.includes('settleDataSyncDate')) {
                    target.hidden('settleDataSyncDate')
                  }
                }
              },
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            }
          }
        },
        buildDictionaryBySelect(vehicleRedeemType, {
          prop: 'redemptionType',
          name: '赎回类型',
          originProp: 'redemptionType',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(1)
          },
          mod: {
            list: {},
            edit: {
              required: true,
              observe(this: DefaultEdit, target, prop, val, from) {
                if (from !== 'init') {
                  if (prop === this.prop) {
                    showItemByType(target, val)
                    initAmountByType(target, val)
                    initAmountReductionRuleByType(target, val)
                    countAmount(target, true)
                  } else {
                    countAmount(target, prop as string)
                  }
                } else {
                  if (prop === this.prop) {
                    showItemByType(target, val)
                    initAmountReductionRuleByType(target, val)
                  }
                }
              },
            },
            show: {
              $type: 'edit',
              required: true,
              disabled: true,
              type: 'select',
              option: {
                list: vehicleRedeemType.getList()
              },
              observe(this: DefaultEdit, target, prop, val, from) {
                if (from === 'init') {
                  if (prop === this.prop) {
                    showItemByType(target, val)
                    initAmountReductionRuleByValue(target)
                  }
                } else {
                  countAmount(target, prop as string)
                }
              },
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            },
            ufo_cs_sh_20: {
              $target: 'show'
            },
            ufo_cs_sh_30: {
              $target: 'show'
            },
            ufo_cs_sh_40: {
              $target: 'show'
            },
          }
        }),
        buildDictionaryBySelect(ApprovalStatus, {
          prop: 'applyStatus',
          name: '审批状态',
          originProp: 'applyStatus',
          originFrom: 'list',
          mod: {
            list: {}
          }
        }),
        {
          prop: 'vehicleAmount',
          name: '车辆金额数据',
          originProp: 'vehicleAmount',
          originFrom: 'list',
          post() {
            return undefined
          },
          mod: {
            edit: {
              type: 'inputNumber',
              disabled: true,
              option: {
                min: 0,
                precision: 2
              },
              observe(this: DefaultEdit, target, prop, val, from) {
                if (from === 'init') {
                  if (prop === this.prop) {
                    target.hidden(this.prop)
                  }
                }
              },
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'principalAmount',
          name: '本金',
          originProp: 'principalAmount',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(1)
          },
          mod: {
            edit: {
              type: 'inputNumber',
              disabled: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            },
            ufo_cs_sh_20: {
              $target: 'edit'
            },
            ufo_cs_sh_30: {
              $target: 'edit'
            },
            ufo_cs_sh_40: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'reductionPrincipalAmount',
          name: '亏损后本金',
          originProp: 'reductionPrincipalAmount',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(2)
          },
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            },
            ufo_cs_sh_20: {
              $target: 'edit'
            },
            ufo_cs_sh_30: {
              $target: 'edit'
            },
            ufo_cs_sh_40: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'interestAmount',
          name: '利息',
          originProp: 'interestAmount',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(1)
          },
          mod: {
            edit: {
              type: 'inputNumber',
              disabled: {
                default: true,
                ufo_cs_sh_20: true,
                ufo_cs_sh_30: true,
                ufo_cs_sh_40: true,
              },
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            },
            ufo_cs_sh_20: {
              $target: 'edit'
            },
            ufo_cs_sh_30: {
              $target: 'edit'
            },
            ufo_cs_sh_40: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'reductionInterestAmount',
          name: '减免后利息',
          originProp: 'reductionInterestAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            },
            ufo_cs_sh_20: {
              $target: 'edit'
            },
            ufo_cs_sh_30: {
              $target: 'edit'
            },
            ufo_cs_sh_40: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'liquidatedAmount',
          name: '违约金',
          originProp: 'liquidatedAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              disabled: {
                default: true,
                ufo_cs_sh_20: true,
                ufo_cs_sh_30: true,
                ufo_cs_sh_40: true,
              },
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            },
            ufo_cs_sh_20: {
              $target: 'edit'
            },
            ufo_cs_sh_30: {
              $target: 'edit'
            },
            ufo_cs_sh_40: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'reductionLiquidatedAmount',
          name: '减免后违约金',
          originProp: 'reductionLiquidatedAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            },
            ufo_cs_sh_20: {
              $target: 'edit'
            },
            ufo_cs_sh_30: {
              $target: 'edit'
            },
            ufo_cs_sh_40: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'hirePurchaseAmount',
          name: '留购价款',
          originProp: 'hirePurchaseAmount',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(2)
          },
          mod: {
            edit: {
              type: 'inputNumber',
              disabled: {
                default: true,
                ufo_cs_sh_20: true,
                ufo_cs_sh_30: true,
                ufo_cs_sh_40: true,
              },
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            },
            ufo_cs_sh_20: {
              $target: 'edit'
            },
            ufo_cs_sh_30: {
              $target: 'edit'
            },
            ufo_cs_sh_40: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'reductionHirePurchaseAmount',
          name: '减免后留购价款',
          originProp: 'reductionHirePurchaseAmount',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(2)
          },
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            },
            ufo_cs_sh_20: {
              $target: 'edit'
            },
            ufo_cs_sh_30: {
              $target: 'edit'
            },
            ufo_cs_sh_40: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'punishAmount',
          name: '罚息',
          originProp: 'punishAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              disabled: {
                default: true,
                ufo_cs_sh_20: true,
                ufo_cs_sh_30: true,
                ufo_cs_sh_40: true,
              },
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            },
            ufo_cs_sh_20: {
              $target: 'edit'
            },
            ufo_cs_sh_30: {
              $target: 'edit'
            },
            ufo_cs_sh_40: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'reductionPunishAmount',
          name: '减免后罚息',
          originProp: 'reductionPunishAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            },
            ufo_cs_sh_20: {
              $target: 'edit'
            },
            ufo_cs_sh_30: {
              $target: 'edit'
            },
            ufo_cs_sh_40: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'collectionAmount',
          name: '收车费用',
          originProp: 'collectionAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              disabled: {
                default: true,
                ufo_cs_sh_20: true,
                ufo_cs_sh_30: true,
                ufo_cs_sh_40: true,
              },
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            },
            ufo_cs_sh_20: {
              $target: 'edit'
            },
            ufo_cs_sh_30: {
              $target: 'edit'
            },
            ufo_cs_sh_40: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'reductionCollectionAmount',
          name: '减免后收车费用',
          originProp: 'reductionCollectionAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            },
            ufo_cs_sh_20: {
              $target: 'edit'
            },
            ufo_cs_sh_30: {
              $target: 'edit'
            },
            ufo_cs_sh_40: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'parkAmount',
          name: '停车费用',
          originProp: 'parkAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              disabled: {
                default: false,
                ufo_cs_sh_20: true,
                ufo_cs_sh_30: true,
                ufo_cs_sh_40: true,
              },
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            },
            ufo_cs_sh_20: {
              $target: 'edit'
            },
            ufo_cs_sh_30: {
              $target: 'edit'
            },
            ufo_cs_sh_40: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'reductionParkAmount',
          name: '减免后停车费用',
          originProp: 'reductionParkAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            },
            ufo_cs_sh_20: {
              $target: 'edit'
            },
            ufo_cs_sh_30: {
              $target: 'edit'
            },
            ufo_cs_sh_40: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'receivableAmount',
          name: '总应收金额',
          originProp: 'receivableAmount',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(1)
          },
          mod: {
            edit: {
              type: 'inputNumber',
              disabled: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_sh_10: {
              $target: 'edit'
            },
            ufo_cs_sh_20: {
              $target: 'edit'
            },
            ufo_cs_sh_30: {
              $target: 'edit'
            },
            ufo_cs_sh_40: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'flowStatusFlag',
          name: '结束流程',
          originProp: 'flowStatusFlag',
          originFrom: 'list',
          edit(value) {
            return value === '1'
          },
          post(value) {
            return value ? '1' : '0'
          },
          mod: {
            edit: {
              type: 'switch',
              required: true,
              tip: {
                data: '结束流程将会拒绝当前申请，请谨慎操作！',
              },
              observe(this: DefaultEdit, target, prop, val) {
                if (prop === this.prop) {
                  onFlowEndChange(target, val as boolean)
                }
              },
            },
            ufo_cs_sh_50: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'payAmount',
          name: '回款金额',
          originProp: 'payAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ufo_cs_sh_50: {
              $target: 'edit'
            },
          }
        },
        {
          prop: 'voucherList',
          name: '回款凭证',
          originProp: 'fileList',
          originFrom: 'local',
          layout: {
            default: layoutParse.getData(1)
          },
          post(value) {
            return value ? (value as any[]).map(item => item.data) : null
          },
          mod: {
            edit: {
              type: 'file',
              multiple: true,
              required: true,
              local: {
                target: {
                  props: {
                    complex: true
                  }
                }
              },
              option: {
                accept: config.file,
                upload (fileList) {
                  return uploadFile(fileList as unknown as File[], 'redeemVoucherFile')
                }
              }
            },
            ufo_cs_sh_50: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'paymentCollectionDate',
          name: '回款日期',
          originProp: 'paymentCollectionDate',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(1)
          },
          mod: {
            edit: {
              type: 'date',
              required: true,
              option: {
                time: {}
              }
            },
            ufo_cs_sh_50: {
              $target: 'edit'
            }
          }
        },
        buildDictionaryBySelect(dict.FLOW_END_REASON, {
          prop: 'flowEndReason',
          name: '结束原因',
          originProp: 'flowEndReason',
          originFrom: 'list',
          mod: {
            edit: {
              required: true
            },
            ufo_cs_sh_50: {
              $target: 'edit'
            }
          }
        }),
        {
          prop: 'flowEndDesc',
          name: '结束描述',
          originProp: 'flowEndDesc',
          originFrom: 'list',
          layout: {
            default: layoutParse.getData(1)
          },
          mod: {
            edit: {
              type: 'textArea',
              required: true
            },
            ufo_cs_sh_50: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'takeCarName',
          name: '提车人姓名',
          originProp: 'takeCarName',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'input',
              required: true
            },
            ufo_cs_sh_70: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'takeCarPhone',
          name: '提车人电话',
          originProp: 'takeCarPhone',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'input',
              required: true,
              option: {
                maxLength: 20
              },
              rules: [
                {
                  validator (rule: any, val?: string) {
                    if (val) {
                      if (RegExpRule.mobilePhone.test(val) || RegExpRule.linePhone.test(val)) {
                        return Promise.resolve()
                      } else {
                        return Promise.reject()
                      }
                    }
                    return Promise.reject()
                  },
                  message: '请输入正确的联系方式'
                }
              ]
            },
            ufo_cs_sh_70: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'takeCarCard',
          name: '提车人身份证',
          originProp: 'takeCarCard',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'input',
              required: true,
              option: {
                maxLength: 18
              },
              rules: [
                {
                  validator (rule: any, val?: string) {
                    if (val) {
                      if (RegExpRule.identityCard.test(val)) {
                        return Promise.resolve()
                      } else {
                        return Promise.reject()
                      }
                    }
                    return Promise.reject()
                  },
                  message: '请输入正确的身份证号'
                }
              ]
            },
            ufo_cs_sh_70: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'attachmentList',
          name: '附件',
          originProp: 'fileList',
          originFrom: 'local',
          layout: {
            default: layoutParse.getData(1)
          },
          post(value) {
            return value ? (value as any[]).map(item => item.data) : null
          },
          mod: {
            edit: {
              type: 'file',
              multiple: true,
              required: true,
              local: {
                target: {
                  props: {
                    complex: true
                  }
                }
              },
              option: {
                accept: config.file,
                upload (fileList) {
                  return uploadFile(fileList as unknown as File[], 'redeemAttachmentFile')
                }
              }
            },
            ufo_cs_sh_70: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'remark',
          name: '备注',
          originProp: 'remark',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'createdBy',
          name: '无',
          originProp: 'createdBy',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'updatedBy',
          name: '无',
          originProp: 'updatedBy',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'updatedTime',
          name: '无',
          originProp: 'updatedTime',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'createdName',
          name: '创建人',
          originProp: 'createdName',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.personnelName
            }
          }
        },
        {
          prop: 'createdTime',
          name: '创建时间',
          originProp: 'createdTime',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.time
            }
          }
        },
      ]
    }
  },
  $getData(this: RedeemList) {
    return new Promise((resolve, reject) => {
      vehicleApi.vehicleRedeem.require({
        ...this.$getSearch(),
        pageNo: this.$getPageData('current')!,
        pageSize: this.$getPageData('size')!
      }).then(res => {
        this.$formatList(res.data.data, res.data.totalCount)
        resolve({ status: 'success' })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
})

export default redeemList
